import { useCallback, type ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import TripListCheckboxButton from './TripListCheckboxButton'

const FilterRowButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${rem(10)};
  width: 100%;
  min-height: ${rem(44)};
  padding: 0;
  border: 0;
  background: transparent;
  color: ${props => props.theme.palette.neutral.surface.normalContrast};
  text-align: start;
  cursor: pointer;
`

const FilterCheckbox = styled(TripListCheckboxButton)`
  flex-shrink: 0;

  &.size-small {
    width: ${rem(16)};
    height: ${rem(16)};
  }

  input:checked:not(:indeterminate) {
    border-color: ${props => props.theme.palette.neutral.surface.normalContrast};
    background-color: ${props => props.theme.palette.neutral.surface.normalContrast};
  }
`

const Label = styled(BodyText)`
  flex: 1;
  min-width: 0;
`

const Count = styled(Caption)`
  min-width: ${rem(16)};
  text-align: end;
  flex-shrink: 0;
`

interface Props<Value extends string> {
  value: Value
  label: string
  count: number
  selected: boolean
  icon?: ReactNode
  onToggle: (value: Value) => void
}

function TripListFilterMenuItem<Value extends string>({ value, label, count, selected, icon, onToggle }: Props<Value>) {
  const handleClick = useCallback(() => {
    onToggle(value)
  }, [onToggle, value])

  return (
    <FilterRowButton type="button" onClick={handleClick}>
      <FilterCheckbox size="small" checked={selected} readOnly />
      {icon}
      <Label variant="large" lineClamp={1}>
        {label}
      </Label>
      <Count variant="large" colour="light-foreground-alt">
        {count}
      </Count>
    </FilterRowButton>
  )
}

export default TripListFilterMenuItem
